export const paymentSources = {
    instaPaidAccount: 'InstaPaidAccount',
    companyAccount: 'CompanyAccount'
};

export const paymentProviders = {
    aiia: 'Aiia',
    danskeBank: 'DanskeBank'
};

export const approvalTypes = {
    manual: 'Manual',
    automatic: 'Automatic'
};

export const ENABLE_SHIFT_TYPES_FOR_PROVIDERS = [
    'Planday',
    'TitanPlan',
    'Staff',
    'Quinyx',
    'SameSystem'
];

export const AUTO_APPROVAL_TIME_PROVIDERS = [
    'Planday',
    'Staff',
    'Tamigo',
    'SameSystem',
    'TitanPlan',
    'Quinyx'
];
export const ALLOW_CONNECTION_TIME_REGISTRATION_EDIT = [
    'Planday',
    'Zenegy',
    'Tamigo',
    'SameSystem',
    'TitanPlan',
    'Staff',
    'Quinyx'
];

export const CREDENTIAL_BASED_AUTH_PROVIDERS = [
    'Planday',
    'Tamigo',
    'SameSystem',
    'TitanPlan',
    'Staff',
    'Quinyx'
];

export const OAUTH_BASED_AUTH_PROVIDERS = ['Zenegy'];

export const CREDENTIAL_BASED_PAYROLL_PROVIDERS = [
    'Intect',
    'ProLoen',
    'Epos',
    'Lessor',
    'DagrofaLon',
    'DataLon'
];

// Supported document languages configuration
export const SUPPORTED_DOCUMENT_LANGUAGES = [
    {
        code: 'da',
        name: 'Danish',
        flag: '/src/icons/flags/denmark.svg'
    },
    {
        code: 'en',
        name: 'English',
        flag: '/src/icons/flags/uk.svg'
    }
    // Add more languages here as needed
    // {
    //     code: 'sv',
    //     name: 'Swedish',
    //     flag: '/src/icons/flags/sweden.svg'
    // }
] as const;
